export const contactFormUrl = process.env.NEXT_PUBLIC_CONTACT_ENDPOINT || ''

export const TERMS_LINK =
  'https://www.coinbase.com/legal/cloud/terms-of-service'
export const PRIVACY_LINK = 'https://www.coinbase.com/legal/privacy'

// TODO: Determine if this key is giving us any value
const i18nKey = 'CloudLeadGen'

export const formMessages = {
  emailConsentMessage: {
    id: `${i18nKey}.emailConsentMessage`,
    defaultMessage:
      'I consent to receive marketing and other communications from Coinbase Asset Management via email.',
    description: 'Email consent message',
  },

  acceptTermsOfUse: {
    id: `${i18nKey}.acceptTermsOfUse`,
    defaultMessage:
      'This communication, including any attachments, is intended only for the use of the addressee and may contain information that is confidential or otherwise protected from disclosure. Any unauthorized use, distribution, modification, forwarding, copying or disclosure is strictly prohibited. If you have received this communication in error, please delete this message, including any attachments, and notify the sender immediately. The information and any disclosures provided herein do not constitute a solicitation or offer to purchase any security or other financial product or investment and is not intended as investment, tax, or legal advice. Unless otherwise noted, all information is estimated, unaudited, and may be subject to revision without notice. Past results are not indicative of future results.  \n \nThis communication may contain statements of opinion, including but not limited to, the author’s analysis and views with respect to: digital assets, projected inflation, macroeconomic policy, and the market in general. Statements of opinion herein have been formulated using the author’s experience, research, and/or analysis, however, such statements also contain elements of subjectivity and are often subjective in nature. In addition, when conducting the analyses on which it bases statements of opinion, the author(s) will incorporate assumptions, which in some cases may be shown to be inaccurate in the future, including in certain material respects. Nothing in this presentation represents a guarantee of any future outcome. The author(s) are under no obligation to update this document, notify any recipients, or re-publish the content contained herein in the event that any factual assertions, assumptions, forward-looking statements, or opinions are subsequently shown to be inaccurate.  \n \nProject Diamond is a smart contract platform developed by Coinbase Asset Management, LLC (“Coinbase AM”), and is for institutional application only.  Features described within this presentation may be conceptual in nature or under development and are subject to change.  In November 2023 Project Diamond completed a live discount note transaction.   Project Diamond has received in-principle approval from the Financial Services Regulated Activity (“FSRA”) of Abu Dhabi Global Market (“ADGM”) to conduct the regulated activity of Developing Financial Technology Services within the RegLab.  \n \nCoinbase AM is a wholly owned subsidiary of Coinbase Global, Inc. Base is a permissionless L2 scaling solution built on the OPStack/Powered by Optimism.  Coinbase and related logos are trademarks of Coinbase, Inc., or its Affiliates.  \n \nThe preceding presentation should not be construed as any tax, accounting, legal or regulatory advice to you and you should satisfy yourself in this regard and ensure that you consult with appropriate advisors to assist in understanding the transactions contemplated by this document. Information provided reflects our views as of a particular time and are subject to change without notice. Prospective investors should not make investment decisions on the basis of any forward-looking statements contained herein.  \n \nThis Presentation contains statements of opinion, including but not limited to, our analysis and views with respect to: digital assets, projected inflation, macroeconomic policy, the market adoption of digital assets, and the market in general. Statements of opinion herein have been formulated using Coinbase AM’s experience, research, and/or analysis, however, such statements also contain elements of subjectivity and are often subjective in nature. In addition, when conducting the analyses on which it bases statements of opinion, we will incorporate assumptions, which in some cases may be shown to be inaccurate in the future, including in certain material respects. Nothing in this presentation represents a guarantee of any future outcome. Information provided reflects our views as of the date of this document and are subject to change without notice. We are under no obligation to update this document, notify any recipients, or republish the content contained herein in the evented by the use of forward-looking terminology such as "may", "will", "should", "expect", "anticipate", "target", "project", "estimate", "intend", "continue" or "believe" or the negatives thereof or other variations thereon or comparable terminology. For that any factual assertions, assumptions, forward-looking statements, or opinions are subsequently shown to be inaccurate.  \n \nCertain information contained herein may have been obtained from third party sources and such information has not been independently verified. No representation, warranty, or undertaking, expressed or implied, is given to the accuracy or completeness of such information by us or any other person. While such sources are believed to be reliable, we do not assume any responsibility for the accuracy or completeness of such information.There is no guarantee that the investment objectives will be achieved. Moreover, PAST PERFORMANCE IS NOT NECESSARILY INDICATIVE OF FUTURE RESULTS.  \n \nThis Presentation may contain statements of opinion, including but not limited to, Coinbase AM’s analysis and views with respect to: digital assets, projected inflation, macroeconomic policy, the market adoption of digital assets, and the market in general. Statements of opinion herein have been formulated using Coinbase AM’s experience, research, and/or analysis, however, such statements also contain elements of subjectivity and are often subjective in nature. In addition, when conducting the analyses on which it bases statements of opinion, Coinbase AM will incorporate assumptions, which in some cases may be shown to be inaccurate in the future, including in certain material respects.  Nothing in this video presentation represents a guarantee of any future outcome. Information provided reflects Coinbase AM’s views as of the date of this video presentation and are subject to change without notice. Coinbase AM is under no obligation to update this Video Presentation, notify any recipients, or re-publish the content contained herein in the event that any factual assertions, assumptions, forward-looking statements, or opinions are subsequently shown to be inaccurate.  \n \nCertain information contained in this Communication constitutes "forward-looking statements," which can be identified by the use of forward-looking terminology such as "may", "will", "should", "expect", "anticipate", "target", "project", "estimate", "intend", "continue" or "believe" or the negatives thereof or other variations thereon or comparable terminology. Forward-looking statements made in this communication are based on current expectations, speak only as of the date of this communication, as the case may be, and are susceptible to a number of risks, uncertainties and other factors. Assumptions relating to the foregoing involve judgments with respect to, among other things, projected inflation, the regulation of digital assets and macroeconomic policy, all of which are difficult or impossible to predict accurately and many of which are beyond our control. In light of the significant uncertainties inherent in the forward-looking statements included herein, the inclusion of such information should not be regarded as a representation to future results or that the objectives and plans expressed or implied by such forward-looking statements will be achieved.  \n \nCertain information contained herein may have been obtained from third-party sources and such information has not been independently verified by the author(s). References herein to third parties are for illustrative purposes and are not an endorsement or recommendation for products or services. No representation, warranty, or undertaking, expressed or implied, is given to the accuracy or completeness of such information. While such sources are believed to be reliable, the author(s) do not assume any responsibility for the accuracy or completeness of such information.',
    description: 'Terms the user accepts during signup',
  },
  firstNameLabel: {
    id: `${i18nKey}.firstNamelabel`,
    defaultMessage: '*First name',
    description: 'key for first name label',
  },
  firstNamePlaceholder: {
    id: `${i18nKey}.firstNamePlaceholder`,
    defaultMessage: 'First name',
    description: 'key for first name placeholder',
  },
  firstNameError: {
    id: `${i18nKey}.firstNameError`,
    defaultMessage: 'Enter your first name',
    description: 'key for first name error message',
  },
  lastNameLabel: {
    id: `${i18nKey}.lastNameLabel`,
    defaultMessage: '*Last name',
    description: 'key for last name label',
  },
  lastNamePlaceholder: {
    id: `${i18nKey}.lastNamePlaceholder`,
    defaultMessage: 'Last name',
    description: 'key for last name placeholder',
  },
  lastNameError: {
    id: `${i18nKey}.lastNameError`,
    defaultMessage: 'Enter your last name',
    description: 'key for last name error message',
  },
  emailLabel: {
    id: `${i18nKey}.emailLabel`,
    defaultMessage: '*Email address',
    description: 'key for email address label',
  },
  emailPlaceholder: {
    id: `${i18nKey}.emailPlaceholder`,
    defaultMessage: 'email@business-email.com',
    description: 'key for email placeholder',
  },
  emailError: {
    id: `${i18nKey}.emailError`,
    defaultMessage: 'Enter your email address',
    description: 'key for last name error message',
  },
  phoneLabel: {
    id: `${i18nKey}.phoneLabel`,
    defaultMessage: 'Phone number',
    description: 'key for phone number label',
  },
  phonePlaceholder: {
    id: `${i18nKey}.phonePlaceholder`,
    defaultMessage: 'Phone number',
    description: 'key for phone placeholder',
  },
  companyNameLabel: {
    id: `${i18nKey}.companyNameLabel`,
    defaultMessage: '*Company name',
    description: 'key for Company name label',
  },
  companyNameError: {
    id: `${i18nKey}.companyNameError`,
    defaultMessage: 'Enter your company name',
    description: 'key for  company name error message',
  },
  companyNamePlaceholder: {
    id: `${i18nKey}.companyNamePlaceholder`,
    defaultMessage: 'Company name',
    description: 'key for Company name placeholder',
  },
  descriptionLabel: {
    id: `${i18nKey}.descriptionLabel`,
    defaultMessage: 'Additional Notes',
    description: 'key for description label',
  },
  descriptionPlaceholder: {
    id: `${i18nKey}.descriptionPlaceholder`,
    defaultMessage: 'Please describe your needs in 500 characters or less.',
    description: 'key for description placeholder',
  },
  descriptionError: {
    id: `${i18nKey}.descriptionError`,
    defaultMessage: 'Please describe how you plan on using our products',
    description: 'key for description error message',
  },
  locationLabel: {
    id: `${i18nKey}.locationLabel`,
    defaultMessage: '*Country',
    description: 'key for description label',
  },
  locationPlaceholder: {
    id: `${i18nKey}.locationPlaceholder`,
    defaultMessage: 'Select',
    description: 'key for description placeholder',
  },
  locationError: {
    id: `${i18nKey}.locationError`,
    defaultMessage: 'Enter your location',
    description: 'key for description error message',
  },
  governmentEntityLabel: {
    id: `${i18nKey}.governmentEntityLabel`,
    defaultMessage: 'Government Entity',
    description: 'key for government entity label',
  },
  governmentEntityPlaceholder: {
    id: `${i18nKey}.governmentEntityPlaceholder`,
    defaultMessage: 'Select',
    description: 'key for government entity placeholder',
  },
  governmentEntityError: {
    id: `${i18nKey}.governmentEntityError`,
    defaultMessage: 'Enter your government entity',
    description: 'key for government entity error message',
  },
  hasOptedOutOfFundsLabel: {
    id: `${i18nKey}.hasOptedOutOfFundsLabel`,
    defaultMessage:
      '*Opt In - I want to learn about CBAM Funds and investment opportunities',
    description: 'key for has opted out of funds label',
  },
  hasOptedOutOfFundsPlaceholder: {
    id: `${i18nKey}.hasOptedOutOfFundsPlaceholder`,
    defaultMessage: 'Select',
    description: 'key for opt in placeholder',
  },
  hasOptedOutOfFundsError: {
    id: `${i18nKey}.hasOptedOutOfFundsError`,
    defaultMessage: 'In order to submit this form, please select an option.',
    description: 'key for opt in error message',
  },
  stayConnectedLabel: {
    id: `${i18nKey}.stayConnectedLabel`,
    defaultMessage: 'How Would You Like to Stay Connected?',
    description: 'key for stay connected label',
  },
  stayConnectedPlaceholder: {
    id: `${i18nKey}.stayConnectedPlaceholder`,
    defaultMessage: 'Select',
    description: 'key for stay connected placeholder',
  },
  stayConnectedError: {
    id: `${i18nKey}.stayConnectedError`,
    defaultMessage: 'Enter your stay connected',
    description: 'key for stay connected error message',
  },
  interestedFundsLabel: {
    id: `${i18nKey}.interestedFundsLabel`,
    defaultMessage: 'Interested Funds',
    description: 'key for interested funds label',
  },
  interestedFundsPlaceholder: {
    id: `${i18nKey}.interestedFundsPlaceholder`,
    defaultMessage: 'Select',
    description: 'key for interested funds placeholder',
  },
  interestedFundsError: {
    id: `${i18nKey}.interestedFundsError`,
    defaultMessage: 'Enter your interested funds',
    description: 'key for interested funds error message',
  },
  currentInvestmentStrategyLabel: {
    id: `${i18nKey}.currentInvestmentStrategyLabel`,
    defaultMessage: 'Current Investment Strategy',
    description: 'key for current investment strategy label',
  },
  currentInvestmentStrategyPlaceholder: {
    id: `${i18nKey}.currentInvestmentStrategyPlaceholder`,
    defaultMessage: 'Select',
    description: 'key for current investment strategy placeholder',
  },
  currentInvestmentStrategyError: {
    id: `${i18nKey}.currentInvestmentStrategyError`,
    defaultMessage: 'Enter your current investment strategy',
    description: 'key for current investment strategy error message',
  },
  investorTypeLabel: {
    id: `${i18nKey}.investorTypeLabel`,
    defaultMessage: 'Investor Type',
    description: 'key for investor type label',
  },
  investorTypePlaceholder: {
    id: `${i18nKey}.investorTypePlaceholder`,
    defaultMessage: 'Select your investor type.',
    description: 'key for investor type placeholder',
  },
  investorTypeError: {
    id: `${i18nKey}.investorTypeError`,
    defaultMessage: 'Enter your investor type',
    description: 'key for investor type error message',
  },
  interestInProductLabel: {
    id: `${i18nKey}.interestInProductLabel`,
    defaultMessage:
      'Are you interested in being contacted to discuss Institutional Products?',
    description: 'key for interest in product label',
  },
  interestInProductPlaceholder: {
    id: `${i18nKey}.interestInProductPlaceholder`,
    defaultMessage: 'Select',
    description: 'key for interest in product placeholder',
  },
  submitSuccessMessage: {
    id: `${i18nKey}.submitSuccessMessage`,
    defaultMessage:
      'Thank you for submitting the Coinbase Asset Management interest form! Our team will review your details and reach out for further information.',
    description: 'key for success banner message',
  },
  submitFailureMessage: {
    id: `${i18nKey}.submitFailureMessage`,
    defaultMessage:
      "There's been an error in your submission of the Coinbase Asset Management interest form. We apologize for the inconvenience. Please re-submit at your earliest convenience.",
    description: 'key for failure banner message',
  },
}

export const defaultValues = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  company: '',
  location: '',
  description: '',
  governmentEntity: '',
  interestInProduct: '',
  newsletterSignup: true,
  investorType: [],
  currentInvestmentStrategy: [],
}

export const leadGenData = {
  formHeader: 'Contact Us',
  firstName: {
    name: 'firstName',
  },
  lastName: {
    name: 'lastName',
  },
  email: {
    name: 'email',
  },
  phone: {
    name: 'phone',
  },
  companyName: {
    name: 'company',
  },

  location: {
    name: 'location',
    optionValues: [
      {
        value: 'US',
        title: 'United States',
        region: 'AMER',
      },
      {
        value: 'CA',
        title: 'Canada',
        region: 'AMER',
      },
      {
        value: 'AD',
        title: 'Andorra',
        region: 'EMEA',
      },
      {
        value: 'AE',
        title: 'United Arab Emirates',
        region: 'EMEA',
      },
      {
        value: 'AF',
        title: 'Afghanistan',
        region: 'EMEA',
      },
      {
        value: 'AG',
        title: 'Antigua and Barbuda',
        region: 'AMER',
      },
      {
        value: 'AI',
        title: 'Anguilla',
        region: 'AMER',
      },
      {
        value: 'AL',
        title: 'Albania',
        region: 'EMEA',
      },
      {
        value: 'AM',
        title: 'Armenia',
        region: 'EMEA',
      },
      {
        value: 'AO',
        title: 'Angola',
        region: 'EMEA',
      },
      {
        value: 'AQ',
        title: 'Antarctica',
        region: 'EMEA',
      },
      {
        value: 'AR',
        title: 'Argentina',
        region: 'AMER',
      },
      {
        value: 'AT',
        title: 'Austria',
        region: 'EMEA',
      },
      {
        value: 'AU',
        title: 'Australia',
        region: 'APAC',
      },
      {
        value: 'AW',
        title: 'Aruba',
        region: 'AMER',
      },
      {
        value: 'AX',
        title: 'Aland Islands',
        region: 'EMEA',
      },
      {
        value: 'AZ',
        title: 'Azerbaijan',
        region: 'EMEA',
      },
      {
        value: 'BA',
        title: 'Bosnia and Herzegovina',
        region: 'EMEA',
      },
      {
        value: 'BB',
        title: 'Barbados',
        region: 'AMER',
      },
      {
        value: 'BD',
        title: 'Bangladesh',
        region: 'APAC',
      },
      {
        value: 'BE',
        title: 'Belgium',
        region: 'EMEA',
      },
      {
        value: 'BF',
        title: 'Burkina Faso',
        region: 'EMEA',
      },
      {
        value: 'BG',
        title: 'Bulgaria',
        region: 'EMEA',
      },
      {
        value: 'BH',
        title: 'Bahrain',
        region: 'EMEA',
      },
      {
        value: 'BI',
        title: 'Burundi',
        region: 'EMEA',
      },
      {
        value: 'BJ',
        title: 'Benin',
        region: 'EMEA',
      },
      {
        value: 'BL',
        title: 'Saint Barthélemy',
        region: 'EMEA',
      },
      {
        value: 'BM',
        title: 'Bermuda',
        region: 'AMER',
      },
      {
        value: 'BN',
        title: 'Brunei Darussalam',
        region: 'APAC',
      },
      {
        value: 'BO',
        title: 'Bolivia, Plurinational State of',
        region: 'AMER',
      },
      {
        value: 'BQ',
        title: 'Bonaire, Sint Eustatius and Saba',
        region: 'AMER',
      },
      {
        value: 'BR',
        title: 'Brazil',
        region: 'AMER',
      },
      {
        value: 'BS',
        title: 'Bahamas',
        region: 'AMER',
      },
      {
        value: 'BT',
        title: 'Bhutan',
        region: 'APAC',
      },
      {
        value: 'BV',
        title: 'Bouvet Island',
        region: 'EMEA',
      },
      {
        value: 'BW',
        title: 'Botswana',
        region: 'EMEA',
      },
      {
        value: 'BY',
        title: 'Belarus',
        region: 'EMEA',
      },
      {
        value: 'BZ',
        title: 'Belize',
        region: 'AMER',
      },
      {
        value: 'CC',
        title: 'Cocos (Keeling) Islands',
        region: 'APAC',
      },
      {
        value: 'CD',
        title: 'Congo, the Democratic Republic of the',
        region: 'EMEA',
      },
      {
        value: 'CF',
        title: 'Central African Republic',
        region: 'EMEA',
      },
      {
        value: 'CG',
        title: 'Congo',
        region: 'EMEA',
      },
      {
        value: 'CH',
        title: 'Switzerland',
        region: 'EMEA',
      },
      {
        value: 'CI',
        title: 'Cote d’Ivoire',
        region: 'EMEA',
      },
      {
        value: 'CK',
        title: 'Cook Islands',
        region: 'EMEA',
      },
      {
        value: 'CL',
        title: 'Chile',
        region: 'AMER',
      },
      {
        value: 'CM',
        title: 'Cameroon',
        region: 'EMEA',
      },
      {
        value: 'CN',
        title: 'China',
        region: 'APAC',
      },
      {
        value: 'CO',
        title: 'Colombia',
        region: 'AMER',
      },
      {
        value: 'CR',
        title: 'Costa Rica',
        region: 'AMER',
      },
      {
        value: 'CU',
        title: 'Cuba',
        region: 'AMER',
      },
      {
        value: 'CV',
        title: 'Cape Verde',
        region: 'EMEA',
      },
      {
        value: 'CW',
        title: 'Curaçao',
        region: 'EMEA',
      },
      {
        value: 'CX',
        title: 'Christmas Island',
        region: 'APAC',
      },
      {
        value: 'CY',
        title: 'Cyprus',
        region: 'EMEA',
      },
      {
        value: 'CZ',
        title: 'Czech Republic',
        region: 'EMEA',
      },
      {
        value: 'DE',
        title: 'Germany',
        region: 'EMEA',
      },
      {
        value: 'DJ',
        title: 'Djibouti',
        region: 'EMEA',
      },
      {
        value: 'DK',
        title: 'Denmark',
        region: 'EMEA',
      },
      {
        value: 'DM',
        title: 'Dominica',
        region: 'AMER',
      },
      {
        value: 'DO',
        title: 'Dominican Republic',
        region: 'AMER',
      },
      {
        value: 'DZ',
        title: 'Algeria',
        region: 'EMEA',
      },
      {
        value: 'EC',
        title: 'Ecuador',
        region: 'AMER',
      },
      {
        value: 'EE',
        title: 'Estonia',
        region: 'EMEA',
      },
      {
        value: 'EG',
        title: 'Egypt',
        region: 'EMEA',
      },
      {
        value: 'EH',
        title: 'Western Sahara',
        region: 'EMEA',
      },
      {
        value: 'ER',
        title: 'Eritrea',
        region: 'EMEA',
      },
      {
        value: 'ES',
        title: 'Spain',
        region: 'EMEA',
      },
      {
        value: 'ET',
        title: 'Ethiopia',
        region: 'EMEA',
      },
      {
        value: 'FI',
        title: 'Finland',
        region: 'EMEA',
      },
      {
        value: 'FJ',
        title: 'Fiji',
        region: 'APAC',
      },
      {
        value: 'FK',
        title: 'Falkland Islands (Malvinas)',
        region: 'AMER',
      },
      {
        value: 'FO',
        title: 'Faroe Islands',
        region: 'EMEA',
      },
      {
        value: 'FR',
        title: 'France',
        region: 'EMEA',
      },
      {
        value: 'GA',
        title: 'Gabon',
        region: 'EMEA',
      },
      {
        value: 'GB',
        title: 'United Kingdom',
        region: 'EMEA',
      },
      {
        value: 'GD',
        title: 'Grenada',
        region: 'AMER',
      },
      {
        value: 'GE',
        title: 'Georgia',
        region: 'EMEA',
      },
      {
        value: 'GF',
        title: 'French Guiana',
        region: 'EMEA',
      },
      {
        value: 'GG',
        title: 'Guernsey',
        region: 'EMEA',
      },
      {
        value: 'GH',
        title: 'Ghana',
        region: 'EMEA',
      },
      {
        value: 'GI',
        title: 'Gibraltar',
        region: 'EMEA',
      },
      {
        value: 'GL',
        title: 'Greenland',
        region: 'EMEA',
      },
      {
        value: 'GM',
        title: 'Gambia',
        region: 'EMEA',
      },
      {
        value: 'GN',
        title: 'Guinea',
        region: 'EMEA',
      },
      {
        value: 'GP',
        title: 'Guadeloupe',
        region: 'EMEA',
      },
      {
        value: 'GQ',
        title: 'Equatorial Guinea',
        region: 'EMEA',
      },
      {
        value: 'GR',
        title: 'Greece',
        region: 'EMEA',
      },
      {
        value: 'GS',
        title: 'South Georgia and the South Sandwich Islands',
        region: 'AMER',
      },
      {
        value: 'GT',
        title: 'Guatemala',
        region: 'AMER',
      },
      {
        value: 'GW',
        title: 'Guinea-Bissau',
        region: 'EMEA',
      },
      {
        value: 'GY',
        title: 'Guyana',
        region: 'AMER',
      },
      {
        value: 'HM',
        title: 'Heard Island and McDonald Islands',
        region: 'EMEA',
      },
      {
        value: 'HN',
        title: 'Honduras',
        region: 'AMER',
      },
      {
        value: 'HR',
        title: 'Croatia',
        region: 'EMEA',
      },
      {
        value: 'HT',
        title: 'Haiti',
        region: 'AMER',
      },
      {
        value: 'HU',
        title: 'Hungary',
        region: 'EMEA',
      },
      {
        value: 'ID',
        title: 'Indonesia',
        region: 'APAC',
      },
      {
        value: 'IE',
        title: 'Ireland',
        region: 'EMEA',
      },
      {
        value: 'IL',
        title: 'Israel',
        region: 'EMEA',
      },
      {
        value: 'IM',
        title: 'Isle of Man',
        region: 'EMEA',
      },
      {
        value: 'IN',
        title: 'India',
        region: 'APAC',
      },
      {
        value: 'IO',
        title: 'British Indian Ocean Territory',
        region: 'APAC',
      },
      {
        value: 'IQ',
        title: 'Iraq',
        region: 'EMEA',
      },
      {
        value: 'IR',
        title: 'Iran, Islamic Republic of',
        region: 'EMEA',
      },
      {
        value: 'IS',
        title: 'Iceland',
        region: 'EMEA',
      },
      {
        value: 'IT',
        title: 'Italy',
        region: 'EMEA',
      },
      {
        value: 'JE',
        title: 'Jersey',
        region: 'EMEA',
      },
      {
        value: 'JM',
        title: 'Jamaica',
        region: 'AMER',
      },
      {
        value: 'JO',
        title: 'Jordan',
        region: 'EMEA',
      },
      {
        value: 'JP',
        title: 'Japan',
        region: 'APAC',
      },
      {
        value: 'KE',
        title: 'Kenya',
        region: 'EMEA',
      },
      {
        value: 'KG',
        title: 'Kyrgyzstan',
        region: 'EMEA',
      },
      {
        value: 'KH',
        title: 'Cambodia',
        region: 'APAC',
      },
      {
        value: 'KI',
        title: 'Kiribati',
        region: 'APAC',
      },
      {
        value: 'KM',
        title: 'Comoros',
        region: 'EMEA',
      },
      {
        value: 'KN',
        title: 'Saint Kitts and Nevis',
        region: 'AMER',
      },
      {
        value: 'KP',
        title: 'Korea, Democratic People’s Republic of',
        region: 'APAC',
      },
      {
        value: 'KR',
        title: 'Korea, Republic of',
        region: 'APAC',
      },
      {
        value: 'KW',
        title: 'Kuwait',
        region: 'EMEA',
      },
      {
        value: 'KY',
        title: 'Cayman Islands',
        region: 'AMER',
      },
      {
        value: 'KZ',
        title: 'Kazakhstan',
        region: 'EMEA',
      },
      {
        value: 'LA',
        title: 'Lao People’s Democratic Republic',
        region: 'APAC',
      },
      {
        value: 'LB',
        title: 'Lebanon',
        region: 'EMEA',
      },
      {
        value: 'LC',
        title: 'Saint Lucia',
        region: 'AMER',
      },
      {
        value: 'LI',
        title: 'Liechtenstein',
        region: 'EMEA',
      },
      {
        value: 'LK',
        title: 'Sri Lanka',
        region: 'APAC',
      },
      {
        value: 'LR',
        title: 'Liberia',
        region: 'EMEA',
      },
      {
        value: 'LS',
        title: 'Lesotho',
        region: 'EMEA',
      },
      {
        value: 'LT',
        title: 'Lithuania',
        region: 'EMEA',
      },
      {
        value: 'LU',
        title: 'Luxembourg',
        region: 'EMEA',
      },
      {
        value: 'LV',
        title: 'Latvia',
        region: 'EMEA',
      },
      {
        value: 'LY',
        title: 'Libya',
        region: 'EMEA',
      },
      {
        value: 'MA',
        title: 'Morocco',
        region: 'EMEA',
      },
      {
        value: 'MC',
        title: 'Monaco',
        region: 'EMEA',
      },
      {
        value: 'MD',
        title: 'Moldova, Republic of',
        region: 'EMEA',
      },
      {
        value: 'ME',
        title: 'Montenegro',
        region: 'EMEA',
      },
      {
        value: 'MF',
        title: 'Saint Martin (French part)',
        region: 'AMER',
      },
      {
        value: 'MG',
        title: 'Madagascar',
        region: 'EMEA',
      },
      {
        value: 'MK',
        title: 'Macedonia, the former Yugoslav Republic of',
        region: 'EMEA',
      },
      {
        value: 'ML',
        title: 'Mali',
        region: 'EMEA',
      },
      {
        value: 'MM',
        title: 'Myanmar',
        region: 'APAC',
      },
      {
        value: 'MN',
        title: 'Mongolia',
        region: 'APAC',
      },
      {
        value: 'MO',
        title: 'Macao',
        region: 'APAC',
      },
      {
        value: 'MQ',
        title: 'Martinique',
        region: 'EMEA',
      },
      {
        value: 'MR',
        title: 'Mauritania',
        region: 'EMEA',
      },
      {
        value: 'MS',
        title: 'Montserrat',
        region: 'AMER',
      },
      {
        value: 'MT',
        title: 'Malta',
        region: 'EMEA',
      },
      {
        value: 'MU',
        title: 'Mauritius',
        region: 'EMEA',
      },
      {
        value: 'MV',
        title: 'Maldives',
        region: 'APAC',
      },
      {
        value: 'MW',
        title: 'Malawi',
        region: 'EMEA',
      },
      {
        value: 'MX',
        title: 'Mexico',
        region: 'AMER',
      },
      {
        value: 'MY',
        title: 'Malaysia',
        region: 'APAC',
      },
      {
        value: 'MZ',
        title: 'Mozambique',
        region: 'EMEA',
      },
      {
        value: 'NA',
        title: 'Namibia',
        region: 'EMEA',
      },
      {
        value: 'NC',
        title: 'New Caledonia',
        region: 'EMEA',
      },
      {
        value: 'NE',
        title: 'Niger',
        region: 'EMEA',
      },
      {
        value: 'NF',
        title: 'Norfolk Island',
        region: 'APAC',
      },
      {
        value: 'NG',
        title: 'Nigeria',
        region: 'EMEA',
      },
      {
        value: 'NI',
        title: 'Nicaragua',
        region: 'AMER',
      },
      {
        value: 'NL',
        title: 'Netherlands',
        region: 'EMEA',
      },
      {
        value: 'NO',
        title: 'Norway',
        region: 'EMEA',
      },
      {
        value: 'NP',
        title: 'Nepal',
        region: 'APAC',
      },
      {
        value: 'NR',
        title: 'Nauru',
        region: 'APAC',
      },
      {
        value: 'NU',
        title: 'Niue',
        region: 'APAC',
      },
      {
        value: 'NZ',
        title: 'New Zealand',
        region: 'APAC',
      },
      {
        value: 'OM',
        title: 'Oman',
        region: 'EMEA',
      },
      {
        value: 'PA',
        title: 'Panama',
        region: 'AMER',
      },
      {
        value: 'PE',
        title: 'Peru',
        region: 'AMER',
      },
      {
        value: 'PF',
        title: 'French Polynesia',
        region: 'EMEA',
      },
      {
        value: 'PG',
        title: 'Papua New Guinea',
        region: 'APAC',
      },
      {
        value: 'PH',
        title: 'Philippines',
        region: 'APAC',
      },
      {
        value: 'PK',
        title: 'Pakistan',
        region: 'APAC',
      },
      {
        value: 'PL',
        title: 'Poland',
        region: 'EMEA',
      },
      {
        value: 'PM',
        title: 'Saint Pierre and Miquelon',
        region: 'EMEA',
      },
      {
        value: 'PN',
        title: 'Pitcairn',
        region: 'APAC',
      },
      {
        value: 'PS',
        title: 'Palestine',
        region: 'EMEA',
      },
      {
        value: 'PT',
        title: 'Portugal',
        region: 'EMEA',
      },
      {
        value: 'PY',
        title: 'Paraguay',
        region: 'AMER',
      },
      {
        value: 'QA',
        title: 'Qatar',
        region: 'EMEA',
      },
      {
        value: 'RE',
        title: 'Reunion',
        region: 'EMEA',
      },
      {
        value: 'RO',
        title: 'Romania',
        region: 'EMEA',
      },
      {
        value: 'RS',
        title: 'Serbia',
        region: 'EMEA',
      },
      {
        value: 'RU',
        title: 'Russian Federation',
        region: 'EMEA',
      },
      {
        value: 'RW',
        title: 'Rwanda',
        region: 'EMEA',
      },
      {
        value: 'SA',
        title: 'Saudi Arabia',
        region: 'EMEA',
      },
      {
        value: 'SB',
        title: 'Solomon Islands',
        region: 'APAC',
      },
      {
        value: 'SC',
        title: 'Seychelles',
        region: 'EMEA',
      },
      {
        value: 'SD',
        title: 'Sudan',
        region: 'EMEA',
      },
      {
        value: 'SE',
        title: 'Sweden',
        region: 'EMEA',
      },
      {
        value: 'SG',
        title: 'Singapore',
        region: 'APAC',
      },
      {
        value: 'SH',
        title: 'Saint Helena, Ascension and Tristan da Cunha',
        region: 'EMEA',
      },
      {
        value: 'SI',
        title: 'Slovenia',
        region: 'EMEA',
      },
      {
        value: 'SJ',
        title: 'Svalbard and Jan Mayen',
        region: 'EMEA',
      },
      {
        value: 'SK',
        title: 'Slovakia',
        region: 'EMEA',
      },
      {
        value: 'SL',
        title: 'Sierra Leone',
        region: 'EMEA',
      },
      {
        value: 'SM',
        title: 'San Marino',
        region: 'EMEA',
      },
      {
        value: 'SN',
        title: 'Senegal',
        region: 'EMEA',
      },
      {
        value: 'SO',
        title: 'Somalia',
        region: 'EMEA',
      },
      {
        value: 'SR',
        title: 'Suriname',
        region: 'AMER',
      },
      {
        value: 'SS',
        title: 'South Sudan',
        region: 'EMEA',
      },
      {
        value: 'ST',
        title: 'Sao Tome and Principe',
        region: 'EMEA',
      },
      {
        value: 'SV',
        title: 'El Salvador',
        region: 'AMER',
      },
      {
        value: 'SX',
        title: 'Sint Maarten (Dutch part)',
        region: 'AMER',
      },
      {
        value: 'SY',
        title: 'Syrian Arab Republic',
        region: 'EMEA',
      },
      {
        value: 'SZ',
        title: 'Swaziland',
        region: 'EMEA',
      },
      {
        value: 'TC',
        title: 'Turks and Caicos Islands',
        region: 'AMER',
      },
      {
        value: 'TD',
        title: 'Chad',
        region: 'EMEA',
      },
      {
        value: 'TF',
        title: 'French Southern Territories',
        region: 'EMEA',
      },
      {
        value: 'TG',
        title: 'Togo',
        region: 'EMEA',
      },
      {
        value: 'TH',
        title: 'Thailand',
        region: 'APAC',
      },
      {
        value: 'TJ',
        title: 'Tajikistan',
        region: 'EMEA',
      },
      {
        value: 'TK',
        title: 'Tokelau',
        region: 'APAC',
      },
      {
        value: 'TL',
        title: 'Timor-Leste',
        region: 'APAC',
      },
      {
        value: 'TM',
        title: 'Turkmenistan',
        region: 'EMEA',
      },
      {
        value: 'TN',
        title: 'Tunisia',
        region: 'EMEA',
      },
      {
        value: 'TO',
        title: 'Tonga',
        region: 'APAC',
      },
      {
        value: 'TR',
        title: 'Turkey',
        region: 'EMEA',
      },
      {
        value: 'TT',
        title: 'Trinidad and Tobago',
        region: 'AMER',
      },
      {
        value: 'TV',
        title: 'Tuvalu',
        region: 'APAC',
      },
      {
        value: 'TW',
        title: 'Taiwan',
        region: 'APAC',
      },
      {
        value: 'TZ',
        title: 'Tanzania, United Republic of',
        region: 'EMEA',
      },
      {
        value: 'UA',
        title: 'Ukraine',
        region: 'EMEA',
      },
      {
        value: 'UG',
        title: 'Uganda',
        region: 'EMEA',
      },
      {
        value: 'UY',
        title: 'Uruguay',
        region: 'AMER',
      },
      {
        value: 'UZ',
        title: 'Uzbekistan',
        region: 'EMEA',
      },
      {
        value: 'VA',
        title: 'Holy See (Vatican City State)',
        region: 'EMEA',
      },
      {
        value: 'VC',
        title: 'Saint Vincent and the Grenadines',
        region: 'AMER',
      },
      {
        value: 'VE',
        title: 'Venezuela, Bolivarian Republic of',
        region: 'AMER',
      },
      {
        value: 'VG',
        title: 'Virgin Islands, British',
        region: 'AMER',
      },
      {
        value: 'VN',
        title: 'Vietnam',
        region: 'APAC',
      },
      {
        value: 'VU',
        title: 'Vanuatu',
        region: 'APAC',
      },
      {
        value: 'WF',
        title: 'Wallis and Futuna',
        region: 'EMEA',
      },
      {
        value: 'WS',
        title: 'Samoa',
        region: 'APAC',
      },
      {
        value: 'YE',
        title: 'Yemen',
        region: 'EMEA',
      },
      {
        value: 'YT',
        title: 'Mayotte',
        region: 'EMEA',
      },
      {
        value: 'ZA',
        title: 'South Africa',
        region: 'EMEA',
      },
      {
        value: 'ZM',
        title: 'Zambia',
        region: 'EMEA',
      },
      {
        value: 'ZW',
        title: 'Zimbabwe',
        region: 'EMEA',
      },
    ],
  },
  description: {
    name: 'description',
  },
  governmentEntity: {
    name: 'governmentEntity',
    optionValues: [
      {
        value: 'Yes',
        title: 'Yes',
      },
      {
        value: 'No',
        title: 'No',
      },
    ],
  },
  investorType: {
    name: 'investorType',
    optionValues: [
      {
        value: 'INVESTOR_TYPE_FOF',
        title: 'LP - Fund of Funds Investor',
      },
      {
        value: 'INVESTOR_TYPE_FAMILY_OFFICE',
        title: 'LP - Family Office',
      },
      {
        value: 'INVESTOR_TYPE_RIA',
        title: 'LP - RIA, Private Wealth Advisor',
      },
      {
        value: 'INVESTOR_TYPE_ALLOCATOR',
        title: 'LP - Allocator (Endowment, Pension, other Asset Owner)',
      },
      {
        value: 'INVESTOR_TYPE_HNW_INVESTOR',
        title: 'LP - HNW/UNHW Investor',
      },
      {
        value: 'INVESTOR_TYPE_CORPORATE_TREASURY',
        title: 'LP - Corporate Treasury',
      },
      {
        value: 'INVESTOR_TYPE_PROTOCOL_TREASURY',
        title: 'LP - Protocol Treasury',
      },
      {
        value: 'INVESTOR_TYPE_GENERAL_PARTNER',
        title: 'General Partner',
      },
      {
        value: '',
        title: 'Other (Add details below)',
      },
    ],
  },
  interestedFunds: {
    name: 'interestedFunds',
    optionValues: [
      {
        value: 'INTERESTED_FUNDS_FUND_BITCOIN_YIELD',
        title: 'Fund - Bitcoin Yield',
      },
      {
        value: 'INTERESTED_FUNDS_FUND_STABLECOIN_PRIVATE_CREDIT',
        title: 'Fund - Stablecoin Private Credit',
      },
      {
        value: 'INTERESTED_FUNDS_TAX_LOSS_HARVESTING_SOLUTIONS',
        title: 'Tax Loss Harvesting solutions',
      },
      {
        value:
          'INTERESTED_FUNDS_INDEX_GOLD_AND_BITCOIN_STORE_OF_VALUE_INDEX_STRATEGY',
        title: 'Index: Gold & Bitcoin - Store of Value Index strategy',
      },
      {
        value: 'INTERESTED_FUNDS_HEDGE_FUND_ALL_TYPES',
        title: 'Hedge Fund - All types',
      },
      {
        value: 'INTERESTED_FUNDS_HEDGE_FUND_LONG_ONLY_DIRECTIONAL_FUNDAMENTAL',
        title: 'Hedge Fund - Long only / Directional / Fundamental',
      },
      {
        value: 'INTERESTED_FUNDS_HEDGE_FUND_LONG_SHORT_TREND_SYSTEMATIC_QUANT',
        title: 'Hedge Fund - Long short / Trend / Systematic Quant',
      },
      {
        value: 'INTERESTED_FUNDS_HEDGE_FUND_MULTI_STRATEGY',
        title: 'Hedge Fund - Multi-strategy',
      },
      {
        value: 'INTERESTED_FUNDS_HEDGE_FUND_MARKET_NEUTRAL',
        title: 'Hedge Fund - Market Neutral (uncorrellated)',
      },
      {
        value: 'INTERESTED_FUNDS_HEDGE_FUND_ONCHAIN_DEFI_STRATEGIES',
        title: 'Hedge Fund - Onchain Defi Strategies',
      },
      {
        value: 'INTERESTED_FUNDS_VENTURE_PRIVATE_ONLY',
        title: 'Venture (private only, no token exposure)',
      },
      {
        value: 'INTERESTED_FUNDS_VENTURE',
        title: 'Venture (liquid token is ok)',
      },
      {
        value: '',
        title: 'Other (Add details below)',
      },
    ],
  },

  currentInvestmentStrategy: {
    name: 'currentInvestmentStrategy',
    optionValues: [
      {
        value: 'CURRENT_INVESTMENT_STRATEGY_CONSIDERING',
        title: 'Considering crypto fund allocation next year.',
      },
      {
        value: 'CURRENT_INVESTMENT_STRATEGY_SOME_EXPOSURE',
        title: 'LP Some exposure from generalist funds (eg VC or Macro)',
      },
      {
        value: 'CURRENT_INVESTMENT_STRATEGY_LP_IN_VC_FUNDS',
        title: 'LP in crypto VC fund(s)',
      },
      {
        value: 'CURRENT_INVESTMENT_STRATEGY_LP_IN_HFUNDS',
        title: 'LP in crypto hedge fund(s)',
      },
      {
        value: 'CURRENT_INVESTMENT_STRATEGY_PLANNING',
        title: 'Plan to make a crypto fund allocation this year.',
      },
      {
        value: 'CURRENT_INVESTMENT_STRATEGY_HOLD_SPOT_EXPOSURE_VIA_ETF',
        title: 'Hold some spot exposure via ETF',
      },
      {
        value:
          'CURRENT_INVESTMENT_STRATEGY_HOLD_SPOT_EXPOSURE_DIRECTLY_IN_A_WALLET_CUSTODIAN',
        title: 'Hold some spot exposure directly in a wallet / custodian',
      },
      {
        value: 'CURRENT_INVESTMENT_STRATEGY_NEED_MORE_EDUCATION',
        title: 'Need more education',
      },
      {
        value: '',
        title: 'Other (Add details below)',
      },
    ],
  },

  stayConnectedMethod: {
    name: 'stayConnectedMethod',
    optionValues: [
      {
        value: 'STAY_CONNECTED_METHOD_VIRTUAL',
        title: 'Virtual - Sign me up for the LP Quarterly call! (LPs only)',
      },
      {
        value: 'STAY_CONNECTED_METHOD_CHAT',
        title:
          'Chat - Add me to the LP Telegram/Whatsapp channel (LPs only) (add handle at end)',
      },
      {
        value: 'STAY_CONNECTED_METHOD_IRL',
        title: 'IRL - Invite me to in-person educational events?',
      },
      {
        value: 'STAY_CONNECTED_METHOD_DEAL_FLOW',
        title:
          'Deal Flow - I am interested in direct and co-invest opportunities',
      },
      {
        value: 'STAY_CONNECTED_METHOD_PERIODIC_UPDATES',
        title: 'Periodic Updates - keep me on email distribution only',
      },
      {
        value: '',
        title: 'Other (Add details below)',
      },
    ],
  },

  /** 
   * I / my firm satisfies the Accredited Investor rules
I / my firm satisfies the Qualified Institutional Investor rules
   * 
   */
  hasOptedOutOfFunds: {
    name: 'hasOptedOutOfFunds',
    optionValues: [
      {
        value: 'Yes - I / my firm satisfies the Accredited Investor rules',
        title: 'Yes - I / my firm satisfies the Accredited Investor rules',
      },
      {
        value:
          'Yes - I / my firm satisfies the Qualified Institutional Investor rules',
        title:
          'Yes - I / my firm satisfies the Qualified Institutional Investor rules',
      },
      {
        value: 'No',
        title: 'No',
      },
    ],
  },

  hasOptedOutOfFundsMap: {
    'Yes - I / my firm satisfies the Accredited Investor rules':
      'HAS_OPTED_OUT_OF_FUND_NO_ACCREDITED_INVESTOR',
    'Yes - I / my firm satisfies the Qualified Institutional Investor rules':
      'HAS_OPTED_OUT_OF_FUND_NO_QUALIFIED_INSTITUTIONAL_INVESTOR',
    No: 'HAS_OPTED_OUT_OF_FUND_YES',
  },

  interestInProduct: {
    name: 'interestInProduct',
    optionValues: [
      {
        value: 'Yes',
        title: 'Yes',
      },
      {
        value: 'No',
        title: 'No',
      },
    ],
  },
}
